import { useQuery, useQueryClient } from "@tanstack/react-query";
import { EndpointsService } from "../services/endpoints/endpoints.service";
import { getLocalStorageUser } from "../services/session/auth.service";

export const useEngagementsCompleted = () => {
	const queryClient = useQueryClient();
	const queryKey = ["reminders"];

	const query = useQuery(queryKey, async () => {
		const response = await EndpointsService.dataRetriever.getEngagements({
			config: {
				params: {
					filters: `patientId==${getLocalStorageUser().id};callType==PHONE;details==COACHING_SESSION,details==TECH_SUPPORT`,
				},
			},
		});
		return response;
	});

	return {
		...query,
		invalidate: () => queryClient.invalidateQueries(queryKey),
	};
};
